"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpAssessmentCard: {
        assigned: 'Assign to',
        questions: 'Questions',
        launch: 'Launch',
        launching: 'Launching',
        scheduled: 'Scheduled',
        scheduledFor: 'Scheduled for',
    },
};
